<template>
  <div class="box">
    <div>基础信息</div>
    <div class="form-box">
      <el-form :model="BasicsInfo">
        <div class="item">
          <el-form-item label="应用模块">
            <el-select
              v-model="BasicsInfo.applicationCode"
              @change="changeApplication"
              placeholder="请选择"
            >
              <el-option
                v-for="item in functionalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.enableFlag !== '1'"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据名称">
            <el-select
              v-model="BasicsInfo.entityName"
              @change="changeBill"
              placeholder="请选择"
              :disabled="billDisabled"
            >
              <el-option
                v-for="item in billOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据代码">
            <el-input v-model="BasicsInfo.entityCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="单据描述">
            <el-input v-model="BasicsInfo.entityDesc"></el-input>
          </el-form-item>
          <el-form-item label="启用日期">
            <el-date-picker
              v-model="BasicsInfo.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="启用" class="check-box">
            <!--<el-input v-model="BasicsInfo.enableFlag"></el-input>-->
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
          <el-form-item label="会计条件">
            <el-input v-model="BasicsInfo.accountCondition"></el-input>
          </el-form-item>
          <el-form-item label="回调接口">
            <el-input v-model="BasicsInfo.accountStatusCallback"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div>
      <div class="public-table">
        <vxe-grid
          border="outer"
          show-overflow
          resizable
          ref="eventData"
          height="280"
          class="vxe-table-element"
          size="mini"
          align="left"
          :auto-resize="true"
          :data="eventData"
          :columns="linkColumnList"
          :toolbar="{}"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          :valid-config="{ autoPos: true, message: 'inline' }"
        >
        </vxe-grid>
      </div>
      <div class="btn-item-detail">
        <!--<a v-hasPermi="['2022010711072276965']" href="javascript:;" @click="$refs.eventData.commitProxy('insert_actived')" class="btn-save"><svg-icon :class="{'icon-img-admin': true, }" style="font-size: 14px;" icon-class="icon-add" />新增</a>-->
        <!--<a v-hasPermi="['2022010711150945061']" href="javascript:;" @click="handleDelete('eventData')" class="btn-save"><svg-icon :class="{'icon-img-admin': true, }" style="font-size: 14px;" icon-class="icon-white-delete" />删除</a>-->
        <a v-hasPermi="['2022010711163569117']" class="btn-save" @click="save()"
          ><svg-icon
            :class="{ 'icon-img-admin': true }"
            style="font-size: 14px"
            icon-class="icon-preserve"
          />保存</a
        >
      </div>
    </div>
  </div>
</template>

<script>
  // import checkbox from '../../../components/form-item/checkbox';
  import { mapState } from 'vuex';
  export default {
    name: 'billDefinitionDetail',
    components: {
      // checkbox,
    },
    data() {
      return {
        BasicsInfo: {
          startDate: '2022-01-01',
          accountCondition: '1==1',
          entityDesc: '',
        },
        checked: '',
        eventData: [],
        functionalOptions: [],
        billOptions: [],
        billDisabled: true,
        allEntityCode: [],
      };
    },
    computed: {
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', visible: true, width: '80' },
          {
            field: 'eventCode',
            title: '事件代码',
          },
          {
            field: 'eventName',
            title: '事件名称',
          },
          {
            field: 'eventDesc',
            title: '事件描述',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'enableFlag',
            title: '启用',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.formatter(row.enableFlag)}</span>];
              },
              edit: ({ row, rowIndex }) => {
                return [
                  <checkbox
                    name=""
                    valueData={row.enableFlag}
                    rowIndex={rowIndex}
                    keyName="enableFlag"
                    valueType="Y"
                    onChange={(val) => this.changeChange(val, row)}
                  ></checkbox>,
                ];
              },
            },
          },
          {
            field: 'accountCondition',
            title: '会计条件',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.loadBasic();
    },
    methods: {
      changeApplication(val) {
        this.billOptions = [];
        for (let key in this.BasicsInfo) {
          if (key !== 'startDate' && key !== 'accountCondition' && key !== 'applicationCode') {
            this.BasicsInfo[key] = '';
          }
        }
        this.loadDict(val);
      },
      async loadDict(val) {
        let options = [];
        await this.$axios
          .post('/maindata/dictData/listDataDictByDataType', { dictType: val })
          .then((res) => {
            options = res.data.data;
            options.forEach((item) => {
              let disabled = this.allEntityCode.indexOf(item.value) !== -1;
              this.billOptions.push({
                label: item.label,
                value: item.value,
                accountStatusCallback: item.remark,
                disabled: disabled,
              });
            });
            this.billDisabled = false;
          });
      },
      changeBill(val) {
        this.eventData = [];
        this.BasicsInfo.entityCode = val;
        this.billOptions.forEach((item) => {
          if (item.value === val) {
            this.BasicsInfo.accountStatusCallback = item.accountStatusCallback;
            this.BasicsInfo.entityDesc = item.label;
          }
        });
        this.$axios
          .post('/maindata/dictData/listDataDictByDataType', { dictType: val })
          .then((res) => {
            let options = res.data.data;
            options.forEach((data) => {
              let params = {
                eventCode: data.value,
                eventName: data.label,
                eventDesc: data.remark,
                enableFlag: data.dataStatus === 0 ? 'N' : 'Y',
                accountCondition: '1==1',
              };
              this.eventData.push(params);
            });
          });
      },
      async loadBasic() {
        let list = await this.$baseRequest.functionalModList();
        let newArr = [];
        list.forEach((item) => {
          if (newArr.indexOf(item.applicationCode) === -1) {
            newArr.push(item.applicationCode);
            this.functionalOptions.push({
              label: item.applicationName,
              value: item.applicationCode,
              enableFlag: item.enableFlag,
            });
          }
        });
        await this.$axios.get('/financial/tAeEntity/queryEntityCodeList').then((res) => {
          this.allEntityCode = res.data.data;
        });
        if (this.$route.query.type === 'edit') {
          this.$axios
            .post('/financial/tAeEntity/queryById', { id: this.$route.query.id })
            .then(async (res) => {
              this.BasicsInfo = res.data.data;
              this.checked = this.BasicsInfo.enableFlag === 'Y';
              this.eventData = await this.$baseRequest.eventList({
                entityCode: this.BasicsInfo.entityCode,
              });
              await this.loadDict(this.BasicsInfo.applicationCode);
            });
        }
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        let ids = [];
        selectedList.forEach((item) => {
          ids.push(item.id);
        });
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$axios.post('/financial/tAeEvent/batchDelete', ids).then(() => {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('cooperation.message.deleteSuccess'),
              });
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      save() {
        this.BasicsInfo.enableFlag = this.checked ? 'Y' : 'N';
        let data = this.$refs.eventData.getTableData().fullData;
        let params = {
          ...this.BasicsInfo,
        };
        params.events = data;
        this.$baseRequest.addBill(params);
        this.$message({ showClose: true, type: 'success', message: '保存成功' });
      },
      formatter(val) {
        return val === 'Y' ? '是' : '否';
      },
      changeChange(val, row) {
        row.enableFlag = val ? 'Y' : 'N';
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    background-color: #ffffff;
    padding: 20px 30px;
  }

  .form-box {
    .el-form-item {
      width: 380px;
      margin-left: 20px;
      ::v-deep .el-form-item__label {
        width: 80px;
      }
      ::v-deep .el-form-item__content {
        margin-left: 80px;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor {
        width: 100%;
      }
    }
    .item {
      display: flex;
      flex-wrap: wrap;
    }

    .check-box {
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #409eff;
        border-color: #409eff;
      }
      ::v-deep .el-checkbox__inner:hover {
        border-color: #409eff;
      }
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #00b400;
      }
    }
  }

  .btn-item-detail {
    padding-top: 20px;
    text-align: center;
  }
</style>
